import { useState } from "react";
import axios from "../../../axios";
import { useNavigate } from "react-router-dom";
import ErrorModal from "../../components/ErrorModal";
import handleApiError from "../../../utils/handleApiError";

export default function SizeCreatePage() {
    const [form, setForm] = useState({ width: "", height: "", type: "small" });
    // const [image, setImage] = useState(null);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append("width", form.width);
        data.append("height", form.height);
        data.append("type", form.type);
        // if (image) data.append("image", image);

        try {
            await axios.post("/admin/sizes", data);
            navigate("/admin/sizes");
        } catch (err) {
        setError(handleApiError(err));
        } finally {
        setLoading(false);
        }    
    };

    return (
        <div className="card mt-24">
            <div className="card-header border-bottom">
                <h4 className="mb-4">Add Sizes</h4>
            </div>
            <ErrorModal error={error} onClose={() => setError("")} />
            <div className="card-body">
                <form onSubmit={handleSubmit}>
                    <div className="row gy-4">
                        <div className="col-sm-6 col-xs-6">
                            <label className="form-label mb-8 h6">Width (cm)</label>
                            <input className="form-control py-11" name="width" placeholder="Width" value={form.width} 
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*\.?\d*$/.test(value)) {
                                setForm({ ...form, width: value });
                                }
                            }}
                            required />
                        </div>

                        <div className="col-sm-6 col-xs-6">
                            <label className="form-label mb-8 h6">Height (cm)</label>
                            <input className="form-control py-11" name="height" placeholder="Height" value={form.height} 
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*\.?\d*$/.test(value)) {
                                setForm({ ...form, height: value });
                                }
                            }}
                            required />
                        </div>

                        <div className="col-sm-6 col-xs-6">
                            <label className="form-label mb-8 h6">Type</label>
                            <select className="form-control py-11" name="type" value={form.type} onChange={handleChange}>
                                <option value="small">Small</option>
                                <option value="medium">Medium</option>
                                <option value="large">Large</option>
                            </select>
                        </div>
                    
                    </div>
                    
                    {/* <input type="file" onChange={(e) => setImage(e.target.files[0])} /> */}
                    <button className="btn btn-main mt-4" type="submit">Save</button>
                </form>
            </div>
        </div>
    );
}
